<template>
  <v-app>
    <v-toolbar>
      <v-toolbar-title>
        <span style="color:orange">Files</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-tooltip bottom color="orange">
          <template v-slot:activator="{on}">
            <v-btn @click="home" v-on="on" flat>
              <v-icon color="orange">home</v-icon>
            </v-btn>
          </template>
          <span style="color:white">Homepage</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>
    <v-parallax
      src="https://firebasestorage.googleapis.com/v0/b/artuseum-75.appspot.com/o/izzatzr%2F8.jpg?alt=media&token=f12c9377-7709-4e6d-8dec-a5b8bd9523e6"
      style="height:100%"
    >
      <v-container>
        <v-layout justify-center align-center column>
          <v-card hover v-for="(i,p) in files" :key="p" class="my-2" :href="i.url">
            <v-layout align-center column>
              <v-card-title primary-title>
                <div>
                  <h3 class="headline mb-0">
                    <a style="color:orange" >{{i.name}}</a>
                  </h3>
                </div>
              </v-card-title>
            </v-layout>
          </v-card>
        </v-layout>
      </v-container>
    </v-parallax>
  </v-app>
</template>

<script>
import firebase from "firebase";
import router from "@/router";
export default {
  data() {
    return {
      files: []
    };
  },
  created() {
    firebase
      .firestore()
      .collection("storage")
      .onSnapshot(e => {
        this.files = e.docs.map(doc => {
          return doc.data();
        });
      });
  },
  methods: {
    home: function() {
      router.push("/portal");
    }
  }
};
</script>

